<template>
<div :class="search_status ? 'index page_fenlei page_shop page_map page_limit' : 'index page_fenlei page_shop page_map' ">
    <!-- 顶部搜索 -->
    <div class="top_wrap">
        <div class="index_top top_nobg">
            <div class="PageSearch page-search">
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder">
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
        </div>
        <!-- 当前页筛选 -->
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <div>
                <!-- 选择项目 -->
                <div class="search_fenlei">
                    <div class="search_title">商品品牌</div>
                    <ul class="search_list clearfix">
                        <li :class="brand.isSelect?'search_item f-l active':'search_item f-l'" v-for="brand in brandList" :key="brand.id" @click="brandClick(brand)">{{brand.name}}</li>
                    </ul>
                </div>
                <!-- 选择分类 -->
                <div class="search_fenlei">
                    <div class="search_title">商品分类</div>
                    <ul class="search_list clearfix">
                        <li :class="cate.isSelect?'search_item f-l active':'search_item f-l'" v-for="cate in goodsCate" :key="cate.id" @click="cateClick(cate)">{{cate.name}}</li>
                    </ul>
                </div>
                <div class="search_fenlei">
                    <div class="search_title">选择分类</div>
                    <ul class="search_list clearfix">
                        <li :class="subCate.isSelect?'search_item f-l active':'search_item f-l'" v-for="subCate in goodsSubCate" :key="subCate.id" @click="subCateClick(subCate)">{{subCate.name}}</li>
                    </ul>
                </div>
                <!-- 价格区间 -->
                <!-- <div class="search_fenlei">
                    <div class="search_title">价格区间(元)</div>
                    <van-field v-model="minPrice" type="digit" label="最低价" />
                    <van-field v-model="maxPrice" type="digit" label="最高价" />
                </div> -->
                <div class="search_fenlei">
                    <div class="search_title">价格区间(元)</div>
                    <div class="price_field">
                        <van-field v-model="minPrice" type="digit" placeholder="最低价格" class="field" />
                        <div class="line"></div>
                        <van-field v-model="maxPrice" type="digit" placeholder="最高价格" class="field" />
                    </div>
                </div>
                <!-- 发货地 -->
                <!-- <div class="search_fenlei">
                    <div class="search_title">发货地</div>
                </div> -->
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 内容区 -->
    <div class="con">
        <div class="tab_wrap">
            <van-tabs v-model="search_tab" :border="false" @click="typeClick">
                <van-tab :name="0">
                    <div slot="title">综合</div>
                </van-tab>
                <van-tab :name="1">
                    <div slot="title">最新</div>
                </van-tab>
                <van-tab :name="2">
                    <div slot="title">销量</div>
                </van-tab>
            </van-tabs>
        </div>
        <!-- 商品列表 -->
        <!-- 分页加载需要用 van-list 对接口时再加-->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadGoodsList">
                <div class="datalist">
                    <ul class="list">
                        <li class="item" v-for="(goods,index) in goodsList" :key="index" @click="goShopDetail(goods)">
                            <div class="thumb">
                                <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt="" /> -->
                                <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" />
                            </div>
                            <!-- <div class="item_xinxi">
                                <div class="title_wrap">
                                    <span class="icon_self" v-if="goods.is_self">自营</span>
                                    <span class="icon_new" v-if="goods.is_new">最新</span>
                                    <span class="title">{{goods.good_title}}</span>
                                </div>
                                <div class="info clearfix">
                                    <span class="f-l price">¥{{goods.good_price}}</span>
                                    <span class="f-r source">{{goods.tradesman_name}}</span>
                                </div>
                            </div> -->
                            <div class="item_xinxi">
                                <div class="title_wrap single">
                                    <div class="title_tag">
                                        <span class="icon_self" v-if="goods.is_self">自营</span>
                                        <span class="icon_new" v-if="goods.is_new">最新</span>
                                    </div>
                                    <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                                    <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                                    <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                                </div>
                                <div class="info clearfix">
                                    <div class="shop_name f-l slh_s">{{ goods.tradesman_name?goods.tradesman_name :'' }}</div>
                                    <div class="source f-r">{{ goods.place }}</div>
                                </div>
                                <div class="info">
                                    <span class="f-l price">¥{{ goods.good_price }}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-list>
        </van-pull-refresh>

        <!-- 遮罩层 -->
        <van-overlay :show="search_status" class="overlay" />
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "goods-list",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            cate_id: null,
            temp_id: null,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan.png', // 搜索栏右侧图标
            search_value: '', // 搜索值
            placeholder: '请输入要搜索的商品',
            righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
            publicPath: process.env.BASE_URL,
            search_tab: 0,
            search_status: false,
            minPrice: 0,
            maxPrice: 99999,
            brandList: [], //品牌数据
            goodsCate: [], //商品分类
            goodsSubCate: [], //二级分类
            goodsList: [], //商品列表
            minPrice: 0,
            maxPrice: 99999,
            price: [], // 价格区间
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			token: null
        };
    },
    created: function () {
        this.cate_id = this.$route.query.cartId
        this.temp_id = this.$route.query.cartId
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '商品'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.loadGoodsCates()
                this.onRefresh()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
        this.loadGoodsCates()
        this.onRefresh()
    },
    methods: {
        brandClick(brand) {
            var brandList = this.brandList
            var newList = []
            for (let i = 0; i < brandList.length; i++) {
                var old = brandList[i];
                if (old.id == brand.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.brandList = newList
        },
        cateClick(cate) {
            var cateList = this.goodsCate
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                if (old.id == cate.id) {
                    old.isSelect = true
                    this.goodsSubCate = old.childList
                } else {
                    old.isSelect = false
                    // var isSelect = false
                    // for (let j = 0; j < old.childList.length; j++) {
                    //     var subCate = old.childList[j];
                    //     if (subCate.isSelect) {
                    //         isSelect = true
                    //         break
                    //     }
                    // }
                    // old.isSelect = isSelect
                }
                cateList[i] = old
            }
            this.goodsCate = cateList
            console.log(this.goodsCate)
        },
        subCateClick(subCate) {
            var goodsSubCate = this.goodsSubCate
            var newList = []
            for (let i = 0; i < goodsSubCate.length; i++) {
                var old = goodsSubCate[i];
                if (old.id == subCate.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.goodsSubCate = newList
            console.log(this.goodsSubCate)
        },
        typeClick(name) {
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.loadGoodsList();
        },
        // 获取数据
        loadGoodsCates() {
            console.log('loadGoodsCates')
            var params = {
                token: this.token
            }
            this.$api.shop.bTobCateInfo(params).then(res => {
                if (res.code == 200) {
                    console.log(res)
                    this.goodsInfo = res.result
                    this.brandList = this.goodsInfo.goodBrand
                    this.goodsTypeList = this.goodsInfo.topCates
                    var goodsCate = []
                    if (this.goodsInfo.middleCates.length > 1) {
                        var isSelect = false
                        for (let i = 0; i < this.goodsInfo.middleCates.length; i++) {
                            var cate = this.goodsInfo.middleCates[i];
                            var cateSelect = false
                            for (let j = 0; j < cate.childList.length; j++) {
                                var subCate = cate.childList[j];
                                if (subCate.id == this.temp_id) {
                                    console.log(subCate.id)
                                    this.temp_id = null
                                    subCate.isSelect = true
                                    cate.isSelect = true
                                    cateSelect = true
                                    isSelect = true
                                    cate.childList[j] = subCate
                                    this.goodsInfo.middleCates[i] = cate
                                    this.goodsSubCate = cate.childList
                                    break
                                }
                            }
                            if (cateSelect == true) {
                                break
                            }
                        }
                        if (isSelect == false) {
                            this.goodsInfo.middleCates[0].isSelect = true
                            this.goodsSubCate = this.goodsInfo.middleCates[0].childList
                        }
                    }
                    this.goodsCate = this.goodsInfo.middleCates
                } else {
                    this.$toast(res.message)
                }
            })
        },
        loadGoodsList() {
            var params = {
                token: this.token,
                page: this.page,
                size: this.size
            };
            //筛选中的分类
            var cateList = this.goodsCate
            var cates = []
            if (this.cate_id != null && this.cate_id != undefined && this.cate_id != 0) {

                params.cate_id = [this.cate_id]
                this.cate_id = null
            } else {
                if (cateList && cateList.length > 0) {
                    for (let i = 0; i < cateList.length; i++) {
                        var old = cateList[i];
                        if (old.isSelect) {
                            for (let j = 0; j < old.childList.length; j++) {
                                var subCate = old.childList[j]
                                if (subCate.isSelect == true) {
                                    cates.push(subCate.id)
                                }
                            }
                        }
                    }
                }
                if (cates.length > 0) {
                    params.cate_id = cates
                }
            }
            if (this.search_tab == 1) {
                params.time_order = 1
            } else if (this.search_tab == 2) {
                params.sale_order = 'desc'
            }
            //价格区间
            var price = [this.minPrice, this.maxPrice]
            if (price) {
                params.price = price
            }
            // 关键字
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.keyword = this.search_value
            }
            //品牌
            var brands = []
            if (this.brandList && this.brandList.length > 0) {
                for (let i = 0; i < this.brandList.length; i++) {
                    var old = this.brandList[i];
                    if (old.isSelect) {
                        brands.push(old.id)
                    }
                }
            }

            if (brands.length > 0) {
                params.brandIds = brands
            }
            console.log(params);
            this.$api.parkmall.goods(params).then((res) => {
                if (res.code == 200) {
                    var list = res.result.list;
                    if (this.page == 1) {
                        this.goodsList = list
                    } else {
                        var old = this.goodsList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.goodsList = old
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message);
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
                console.log(this.loading)
            });
        },
        // 商品详情
        goShopDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
        // 点击搜索图标
        search() {
            this.onRefresh()
        },
        // 右侧图标
        clicksearchright() {
            this.search_status = !this.search_status
        },
        // 重置
        reset() {
            var brandList = this.brandList
            var newList = []
            for (let i = 0; i < brandList.length; i++) {
                var old = brandList[i];
                old.isSelect = false
                newList.push(old)
            }
            this.brandList = newList
            var cateList = this.goodsCate
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                old.isSelect = false
                for (let j = 0; j < old.childList.length; j++) {
                    var subCate = old.childList[j];
                    subCate.isSelect = false
                    old.childList[j] = subCate
                }
                // if (i == 0) {
                //     this.goodsSubCate = old.childList
                //     old.isSelect = true
                // }
                cateList[i] = old
            }
            this.goodsCate = cateList
            // 价格重置
            this.minPrice = 0
            this.maxPrice = 99999
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
